// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__7sUEm","item":"BottomNav_item__op+oL","active":"BottomNav_active__4l86U","iconWrap":"BottomNav_iconWrap__hKoo0","badge":"BottomNav_badge__yD21z"};